import { Component, Input } from '@angular/core';

import { AnnotationType } from '../models/iannotation';
import { LayerViewModel } from '../view-models/chart-viewmodel';

import { CssMediaService } from '@se/se.ui.html5';
import { MainMeasuresService } from '../utils/main-measures.service';

@Component({
    selector: 'ecg-summary',
    templateUrl: './ecg-summary.component.html',
    styleUrls: ['./ecg-summary.component.css', './ecg-summary.component.16_9.css'],
})
export class EcgSummaryComponent {
    // Data Members

    private _layer: LayerViewModel | null = null;
    get layer() {
        return this._layer;
    }
    @Input()
    set layer(layer: LayerViewModel | null) {
        if (!layer) return;
        this._layer = layer;

        this.updateMeasures();
    }

    @Input()
    showConclusion: boolean = true;

    // Constructor

    constructor(public cssMediaService: CssMediaService, public mainMeasuresService: MainMeasuresService) {}

    // private functions

    private updateMeasures() {
        if (this._layer == null || this._layer.ecgData == null) return;

        let valueAnnotations = this._layer.ecgData.originalWaveform.annotations.filter(
            (annotation) => annotation.type == AnnotationType.VALUE,
        );
        this.mainMeasuresService.extracts(valueAnnotations);
    }
}
